import { IconX } from '@tabler/icons-react';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { uploadImage } from '../../../api/api.global';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const UpdateOrgModal = ({ buttonComponent, orgData, callback }) => {

    const [show, setShow] = useState(false);
    const [file, setFile] = useState(null);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    function fileOnChange(event) {
        let file = event.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            setFile(null);
            event.target.value = null;
        } else {
            setFile(file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                document.getElementById('pic-preview').src = reader.result;
            }
        }
    }

    const update = async () => {
        const name = document.getElementById('name').value;
        if (name?.toLowerCase() === 'default') {
            toast.error('Organization name cannot be "Default".');
            return;
        }
        loadingShow();
        let postData = {
            organizationIcon: file ? await uploadImage(file, "advy-org-profile-pic") : orgData.profilePic,
            name: name,
            organizationId: orgData?.organizationId
        }
        let response = await postApi(postData, urlApi.updateOrgDetails);
        loadingHide();
        if (response.responseCode === 200) {
            toast.success(response?.message);
            callback?.();
            handleClose();
        } else {
            toast.error(response?.message);
        }
    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow}>{buttonComponent}</div>
            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Update Organization ({orgData?.name}).</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className="grid grid-cols-1 gap-3 mb-3">
                        <div className="">
                            <label htmlFor="name" className='text-sm font-semibold mb-1'>Name</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='name' defaultValue={orgData?.name} />
                        </div>
                        <div className="">
                            <label htmlFor="admin-profile-file" className='text-sm font-semibold mb-1'>Profile Picture (Max 5Mb)</label>
                            <input type="file" name="" id="admin-profile-file" onChange={(e) => fileOnChange(e)} className='w-full px-3 py-2 rounded-md border-2 text-sm' accept="image/png, image/gif, image/jpeg" />
                        </div>
                        <img src={orgData?.organizationIcon} alt="" id='pic-preview' className='max-h-[200px] max-w-full object-contain rounded-md mx-auto mt-4' />
                    </div>
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => update()}>Update</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UpdateOrgModal